<template>
  <div style="min-height:300px;">
    <RwvLoader :isLoading="isLoadingHome" :fullPage="false"></RwvLoader>
    <RwvProduct :products="hotProducts" />  
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import RwvProCategory from "@/components/ProCategory";
import { FETCH_HOT_PRODUCTS, FETCH_SERVICES, FETCH_SUPPORTS } from "@/store/actions.type";
import RwvLoader from "@/components/Loader";
import carousel from "vue-owl-carousel";
import RwvProduct from "@/components/sections/Product";
export default {
  name: "home",
  components: {
    RwvProCategory,
    RwvLoader,      
    RwvProduct,
  },
  mounted() {
    Promise.all([this.$store.dispatch(FETCH_HOT_PRODUCTS),
    this.$store.dispatch(FETCH_SERVICES),
    this.$store.dispatch(FETCH_SUPPORTS)]).then(() => {});
  },
  computed: {
    ...mapGetters(["categories", "hotProducts", "services", "supports", "isLoadingHome"])
  }
};
</script>
